import { render, staticRenderFns } from "./FinancialReport.vue?vue&type=template&id=0b0540e7&scoped=true&"
import script from "./FinancialReport.vue?vue&type=script&lang=js&"
export * from "./FinancialReport.vue?vue&type=script&lang=js&"
import style0 from "./FinancialReport.vue?vue&type=style&index=0&id=0b0540e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0540e7",
  null
  
)

export default component.exports